import { Directive, ElementRef, HostListener } from "@angular/core";
import { Tooltip } from "primeng/tooltip";

@Directive({
  selector: '[pTooltip][appShowToolTipIfTruncated]'
})
export class TruncatedDirective {
  constructor(
    private pToolTip: Tooltip,
    private elementRef: ElementRef<HTMLElement>
  ) {
    // workaround for PrimeNG 16 bug.
    pToolTip._tooltipOptions.appendTo = 'body';
  }

  @HostListener('mouseenter', ['$event'])
  setTooltipState(): void {
    const element = this.elementRef.nativeElement;
    const disable = element.scrollWidth <= element.clientWidth;
    if (disable) {
      setTimeout(() => {
        this.pToolTip.disabled = disable;
      }, 0);
    }
  }
}